export default (theme) => ({
  alert: {
    padding: '16px 18px',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: `${theme.palette.secondary.main}30`,
  },
  title: {
    fontSize: 14,
    marginLeft: 15,
    color: theme.palette.secondary.main,
  },
});
